var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clubClass_right2"}},[_c('div',{staticClass:"cc-header"},[_vm._v("参与度排名")]),_c('div',{staticClass:"main-value"},[_c('dv-scroll-ranking-board',{staticClass:"rankChart",attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }